import { c as _c } from "react/compiler-runtime";
import { useBoolean } from 'minimal-shared/hooks';
import { mergeClasses } from 'minimal-shared/utils';
import Collapse from '@mui/material/Collapse';
import { NavList } from './nav-list';
import { Nav, NavUl, NavLi, NavSubheader } from '../components';
import { navSectionClasses, navSectionCssVars } from '../styles';

// ----------------------------------------------------------------------

export function NavSectionVertical(t0) {
  const $ = _c(38);
  let className;
  let currentRole;
  let data;
  let enabledRootRedirect;
  let other;
  let overridesVars;
  let render;
  let slotProps;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      data,
      render,
      className,
      slotProps,
      currentRole,
      enabledRootRedirect,
      cssVars: overridesVars,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = currentRole;
    $[3] = data;
    $[4] = enabledRootRedirect;
    $[5] = other;
    $[6] = overridesVars;
    $[7] = render;
    $[8] = slotProps;
    $[9] = sx;
  } else {
    className = $[1];
    currentRole = $[2];
    data = $[3];
    enabledRootRedirect = $[4];
    other = $[5];
    overridesVars = $[6];
    render = $[7];
    slotProps = $[8];
    sx = $[9];
  }
  let t1;
  if ($[10] !== className) {
    t1 = mergeClasses([navSectionClasses.vertical, className]);
    $[10] = className;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== overridesVars) {
    t2 = theme => ({
      ...navSectionCssVars.vertical(theme),
      ...overridesVars
    });
    $[12] = overridesVars;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== sx) {
    t3 = Array.isArray(sx) ? sx : [sx];
    $[14] = sx;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t2 || $[17] !== t3) {
    t4 = [t2, ...t3];
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      flex: "1 1 auto",
      gap: "var(--nav-item-gap)"
    };
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== currentRole || $[21] !== data || $[22] !== enabledRootRedirect || $[23] !== render || $[24] !== slotProps) {
    let t7;
    if ($[26] !== currentRole || $[27] !== enabledRootRedirect || $[28] !== render || $[29] !== slotProps) {
      t7 = group => <Group key={group.subheader ?? group.items[0].title} subheader={group.subheader} items={group.items} render={render} slotProps={slotProps} currentRole={currentRole} enabledRootRedirect={enabledRootRedirect} />;
      $[26] = currentRole;
      $[27] = enabledRootRedirect;
      $[28] = render;
      $[29] = slotProps;
      $[30] = t7;
    } else {
      t7 = $[30];
    }
    t6 = data.map(t7);
    $[20] = currentRole;
    $[21] = data;
    $[22] = enabledRootRedirect;
    $[23] = render;
    $[24] = slotProps;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[31] !== t6) {
    t7 = <NavUl sx={t5}>{t6}</NavUl>;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  let t8;
  if ($[33] !== other || $[34] !== t1 || $[35] !== t4 || $[36] !== t7) {
    t8 = <Nav className={t1} sx={t4} {...other}>{t7}</Nav>;
    $[33] = other;
    $[34] = t1;
    $[35] = t4;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  return t8;
}
function Group(t0) {
  const $ = _c(11);
  const {
    items,
    render,
    subheader,
    slotProps,
    currentRole,
    enabledRootRedirect
  } = t0;
  const groupOpen = useBoolean(true);
  let t1;
  if ($[0] !== currentRole || $[1] !== enabledRootRedirect || $[2] !== items || $[3] !== render || $[4] !== slotProps) {
    t1 = () => <NavUl sx={{
      gap: "var(--nav-item-gap)"
    }}>{items.map(list => <NavList key={list.title} data={list} render={render} depth={1} slotProps={slotProps} currentRole={currentRole} enabledRootRedirect={enabledRootRedirect} />)}</NavUl>;
    $[0] = currentRole;
    $[1] = enabledRootRedirect;
    $[2] = items;
    $[3] = render;
    $[4] = slotProps;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const renderContent = t1;
  let t2;
  if ($[6] !== groupOpen || $[7] !== renderContent || $[8] !== slotProps?.subheader || $[9] !== subheader) {
    t2 = <NavLi>{subheader ? <><NavSubheader data-title={subheader} open={groupOpen.value} onClick={groupOpen.onToggle} sx={slotProps?.subheader}>{subheader}</NavSubheader><Collapse in={groupOpen.value}>{renderContent()}</Collapse></> : renderContent()}</NavLi>;
    $[6] = groupOpen;
    $[7] = renderContent;
    $[8] = slotProps?.subheader;
    $[9] = subheader;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}